import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { X } from "lucide-react";

interface CustomHeadersSectionProps {
  customHeaders: Array<{ key: string; value: string }>;
  showCustomHeaders: boolean;
  onToggle: () => void;
  onAdd: () => void;
  onRemove: (index: number) => void;
  onUpdate: (index: number, field: "key" | "value", value: string) => void;
}

export function CustomHeadersSection({
  customHeaders,
  showCustomHeaders,
  onToggle,
  onAdd,
  onRemove,
  onUpdate,
}: CustomHeadersSectionProps) {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-foreground">
            Custom Headers
          </span>
          {customHeaders.length > 0 && (
            <span className="text-xs text-muted-foreground">
              ({customHeaders.length})
            </span>
          )}
        </div>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={onAdd}
          className="text-xs"
        >
          Add Header
        </Button>
      </div>

      <p className="text-xs text-muted-foreground">
        Add custom HTTP headers to include with every request (e.g. API keys,
        authorization)
      </p>

      {customHeaders.length > 0 ? (
        <div className="space-y-2 max-h-48 overflow-y-auto">
          {customHeaders.map((header, index) => (
            <div
              key={index}
              className="flex gap-2 items-center p-3 bg-muted/30 rounded-lg border border-border"
            >
              <Input
                placeholder="Header name"
                value={header.key}
                onChange={(e) => onUpdate(index, "key", e.target.value)}
                className="h-8 text-xs flex-1"
              />
              <Input
                placeholder="Header value"
                value={header.value}
                onChange={(e) => onUpdate(index, "value", e.target.value)}
                className="h-8 text-xs flex-1"
              />
              <Button
                type="button"
                variant="ghost"
                size="sm"
                onClick={() => onRemove(index)}
                className="h-8 w-8 p-0 text-muted-foreground hover:text-destructive flex-shrink-0"
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
          ))}
        </div>
      ) : (
        <div className="border border-dashed border-border rounded-lg p-6 text-center bg-muted/20">
          <p className="text-sm text-muted-foreground">
            No custom headers configured
          </p>
        </div>
      )}
    </div>
  );
}
